// import React from "react";


// const prices = [
//   { label: "Under ₹149", value: 149 },
//   { label: "Under ₹199", value: 199 },
//   { label: "Under ₹499", value: 499 },
//   { label: "Under ₹999", value: 999 }
// ];

// const PriceFilter = ({ filters, setFilters }) => {
//   return (
//     <div>
//       <h4 className="font-medium mb-2">Price</h4>
//       <div className="space-y-2">
//         {prices.map((p) => (
//           <label key={p.value} className="flex items-center gap-2 text-sm">
//             <input
//               type="radio"
//               name="price"
//               checked={filters.price === p.value}
//               onChange={() =>
//                 setFilters((prev) => ({ ...prev, price: p.value }))
//               }
//             />
//             {p.label}
//           </label>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default PriceFilter;


// import React, { useEffect, useState } from "react";

// const MIN_PRICE = 0;
// const MAX_PRICE = 6000;
// const STEP = 100;

// const PriceFilter = ({ filters, setFilters }) => {
//   const [min, setMin] = useState(filters.price.min ?? MIN_PRICE);
//   const [max, setMax] = useState(filters.price.max ?? MAX_PRICE);

//   /* 🔄 Sync with global filters */
//   useEffect(() => {
//     setFilters((prev) => ({
//       ...prev,
//       price: { min, max }
//     }));
//   }, [min, max]);

//   const minPercent = (min / MAX_PRICE) * 100;
//   const maxPercent = (max / MAX_PRICE) * 100;

//   return (
//     <div>
//       <h4 className="font-medium mb-3">Price</h4>

//       {/* SLIDER TRACK */}
//       <div className="relative h-1 bg-gray-300 rounded">
//         <div
//           className="absolute h-1 bg-pink-500 rounded"
//           style={{
//             left: `${minPercent}%`,
//             width: `${maxPercent - minPercent}%`
//           }}
//         />
//       </div>

//       {/* RANGE INPUTS */}
//       <div className="relative mt-[-6px]">
//         {/* MIN */}
//         <input
//           type="range"
//           min={MIN_PRICE}
//           max={MAX_PRICE}
//           step={STEP}
//           value={min}
//           onChange={(e) =>
//             setMin(Math.min(+e.target.value, max - STEP))
//           }
//           className="absolute w-full appearance-none bg-transparent pointer-events-none"
//         />

//         {/* MAX */}
//         <input
//           type="range"
//           min={MIN_PRICE}
//           max={MAX_PRICE}
//           step={STEP}
//           value={max}
//           onChange={(e) =>
//             setMax(Math.max(+e.target.value, min + STEP))
//           }
//           className="absolute w-full appearance-none bg-transparent pointer-events-none"
//         />
//       </div>

//       {/* PRICE LABEL */}
//       <div className="flex justify-between text-sm text-gray-700 mt-6">
//         <span>₹{min.toLocaleString()}</span>
//         <span>₹{max.toLocaleString()}</span>
//       </div>
//     </div>
//   );
// };

// export default PriceFilter;


// import React, { useEffect, useState } from "react";

// const GAP = 100;

// const PriceFilter = ({ filters, setFilters, priceBounds }) => {
//   const MIN_PRICE = priceBounds?.min ?? 0;
//   const MAX_PRICE = priceBounds?.max ?? 0;

//   const [min, setMin] = useState(MIN_PRICE);
//   const [max, setMax] = useState(MAX_PRICE);

//   useEffect(() => {
//     if (priceBounds?.min !== undefined && priceBounds?.max !== undefined) {
//       setMin(priceBounds.min);
//       setMax(priceBounds.max);

//       setFilters((prev) => ({
//         ...prev,
//         price: null // ⬅️ IMPORTANT: do NOT activate filter on load
//       }));
//     }
//   }, [priceBounds]);

//   /* 🔑 APPLY FILTER ONLY ON USER MOVE */
//   useEffect(() => {
//     if (min !== MIN_PRICE || max !== MAX_PRICE) {
//       setFilters((prev) => ({
//         ...prev,
//         price: { min, max }
//       }));
//     }
//   }, [min, max]);

//   if (!priceBounds) return null;

//   const minPercent =
//     ((min - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;
//   const maxPercent =
//     ((max - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;

//   return (
//     <div>
//       <h4 className="font-medium mb-3">Price</h4>

//       {/* SLIDER CONTAINER */}
//       <div className="relative h-6">

//         {/* BASE TRACK */}
//         <div className="absolute top-1/2 -translate-y-1/2 w-full h-1 bg-gray-300 rounded" />

//         {/* ACTIVE RANGE */}
//         <div
//           className="absolute top-1/2 -translate-y-1/2 h-1 bg-pink-500 rounded"
//           style={{
//             left: `${minPercent}%`,
//             width: `${maxPercent - minPercent}%`
//           }}
//         />

//         {/* MIN THUMB */}
//         <input
//           type="range"
//           min={MIN_PRICE}
//           max={MAX_PRICE}
//           value={min}
//           onChange={(e) =>
//             setMin(Math.min(+e.target.value, max - GAP))
//           }
//           className="absolute w-full top-1 pointer-events-none appearance-none bg-transparent z-20"
//         />

//         {/* MAX THUMB */}
//         <input
//           type="range"
//           min={MIN_PRICE}
//           max={MAX_PRICE}
//           value={max}
//           onChange={(e) =>
//             setMax(Math.max(+e.target.value, min + GAP))
//           }
//           className="absolute w-full top-1 pointer-events-none appearance-none bg-transparent z-30"
//         />
//       </div>

//       {/* PRICE LABEL */}
//       <div className="flex justify-between text-sm mt-2">
//         <span>₹{min}</span>
//         <span>₹{max}</span>
//       </div>

//     </div>
//   );
// };

// export default PriceFilter;


// import React, { useEffect, useState, useRef } from "react";

// const GAP = 100;

// const PriceFilter = ({ filters, setFilters, priceBounds }) => {
//   // ✅ Always define bounds safely
//   const MIN_PRICE = priceBounds?.min ?? 0;
//   const MAX_PRICE = priceBounds?.max ?? 0;

//   // ✅ Hooks MUST be unconditional
//   const [min, setMin] = useState(MIN_PRICE);
//   const [max, setMax] = useState(MAX_PRICE);
//   const userTouched = useRef(false);

//   /* Reset slider on Clear All */
//   useEffect(() => {
//     if (
//       filters.price?.min === null &&
//       filters.price?.max === null
//     ) {
//       setMin(MIN_PRICE);
//       setMax(MAX_PRICE);
//       userTouched.current = false;
//     }
//   }, [filters.price, MIN_PRICE, MAX_PRICE]);

//   /* Apply filter only after user moves slider */
//   useEffect(() => {
//     if (!userTouched.current) return;

//     setFilters((prev) => ({
//       ...prev,
//       price: { min, max }
//     }));
//   }, [min, max, setFilters]);

//   // ✅ Conditional UI rendering (NOT hooks)
//   if (!priceBounds || MIN_PRICE === MAX_PRICE) {
//     return null;
//   }

//   const minPercent =
//     ((min - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;
//   const maxPercent =
//     ((max - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;

//   return (
//     <div>
//       <h4 className="font-medium mb-3">Price</h4>

//       <div className="relative h-6">
//         {/* Base track */}
//         <div className="absolute top-1/2 -translate-y-1/2 w-full h-1 bg-gray-300 rounded" />

//         {/* Active range */}
//         <div
//           className="absolute top-1/2 -translate-y-1/2 h-1 bg-pink-500 rounded"
//           style={{
//             left: `${minPercent}%`,
//             width: `${maxPercent - minPercent}%`
//           }}
//         />

//         {/* Min thumb */}
//         <input
//           type="range"
//           min={MIN_PRICE}
//           max={MAX_PRICE}
//           value={min}
//           onChange={(e) => {
//             userTouched.current = true;
//             setMin(Math.min(+e.target.value, max - GAP));
//           }}
//           className="absolute w-full top-1 appearance-none bg-transparent z-20"
//         />

//         {/* Max thumb */}
//         <input
//           type="range"
//           min={MIN_PRICE}
//           max={MAX_PRICE}
//           value={max}
//           onChange={(e) => {
//             userTouched.current = true;
//             setMax(Math.max(+e.target.value, min + GAP));
//           }}
//           className="absolute w-full top-1 appearance-none bg-transparent z-30"
//         />
//       </div>

//       <div className="flex justify-between text-sm mt-2">
//         <span>₹{min}</span>
//         <span>₹{max}</span>
//       </div>
//     </div>
//   );
// };

// export default PriceFilter;

import React, { useEffect, useState, useRef } from "react";

const GAP = 100;

const PriceFilter = ({ filters, setFilters, priceBounds }) => {
  const userInteracted = useRef(false);

  const MIN_PRICE = priceBounds?.min ?? 0;
  const MAX_PRICE = priceBounds?.max ?? 0;

  const [min, setMin] = useState(MIN_PRICE);
  const [max, setMax] = useState(MAX_PRICE);

  /* ✅ Sync slider ONLY when filters change externally */
  useEffect(() => {
    if (!priceBounds) return;

    if (
      filters.price?.min !== null &&
      filters.price?.max !== null
    ) {
      setMin(filters.price.min);
      setMax(filters.price.max);
    } else {
      setMin(MIN_PRICE);
      setMax(MAX_PRICE);
    }

    userInteracted.current = false;
  }, [filters.price, MIN_PRICE, MAX_PRICE, priceBounds]);

  /* ✅ Apply filter ONLY after user action */
  useEffect(() => {
    if (!userInteracted.current) return;

    setFilters((prev) => ({
      ...prev,
      price: { min, max }
    }));
  }, [min, max, setFilters]);

  if (!priceBounds || MIN_PRICE === MAX_PRICE) return null;

  const minPercent =
    ((min - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;
  const maxPercent =
    ((max - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;

  return (
    <div>
      <h4 className="font-medium mb-3">Price</h4>

      <div className="relative h-6">
        {/* Base track */}
        <div className="absolute top-1/2 -translate-y-1/2 w-full h-1 bg-gray-300 rounded" />

        {/* Active range */}
        <div
          className="absolute top-1/2 -translate-y-1/2 h-1 bg-pink-500 rounded"
          style={{
            left: `${minPercent}%`,
            width: `${maxPercent - minPercent}%`
          }}
        />

        {/* MIN thumb */}
        <input
          type="range"
          min={MIN_PRICE}
          max={MAX_PRICE}
          value={min}
          onChange={(e) => {
            userInteracted.current = true;
            setMin(Math.min(+e.target.value, max - GAP));
          }}
          className="absolute w-full top-1 appearance-none bg-transparent z-10"
        />

        {/* MAX thumb */}
        <input
          type="range"
          min={MIN_PRICE}
          max={MAX_PRICE}
          value={max}
          onChange={(e) => {
            userInteracted.current = true;
            setMax(Math.max(+e.target.value, min + GAP));
          }}
          className="absolute w-full top-1 appearance-none bg-transparent z-20"
        />
      </div>

      <div className="flex justify-between text-sm mt-2">
        <span>₹{min}</span>
        <span>₹{max}</span>
      </div>
    </div>
  );
};

export default PriceFilter;
